module.exports = __webpack_public_path__ + "media/images/mobile/abouts/5-c3ef7664d47d5685ff6ea96e2ead719e.jpg";